export default __webpack_public_path__ + "static/media/engagement.4105af81.png";